<div class="container">
  <div class="header">
    <h4>2. Select Worksheet</h4>
  </div>

  <div
    class="content"
    [ngClass]="{ 'grey-background': !worksheets || worksheets.length < 1 }"
  >
    <div *ngIf="!worksheets || worksheets.length < 1" class="no-file-present">
      No File Selected
    </div>

    <div *ngIf="worksheets && worksheets.length > 0" class="tabs-present">
      <div *ngFor="let worksheet of worksheets" class="single-worksheet">
        <div>
          <label
            ><input
              type="radio"
              name="radio"
              [value]="worksheet"
              (change)="updateSelection(worksheet)"
              [(ngModel)]="selectedWorksheet"
            />{{ worksheet.name }}</label
          >
        </div>
        <div class="worksheet-label" [ngClass]="selectedWorksheet.name !== worksheet.name ? 'bg-gray-600' : 'bg-primary'">
          {{selectedWorksheet.name !== worksheet.name ? 'Ignore' : 'Include'}}
        </div>
      </div>
    </div>
  </div>
</div>
